import { Model } from '@shared-features/models/model';
import { Expose, Type } from 'class-transformer';
import { ShipmentIntegrationActionConfig } from '@features/shipments/models/shipment-integration-action-config.model';
import { ShipmentIntegrationAction } from '@features/shipments/models/shipment-integration-action.model';
import { IntegrationType } from '../enums/integration-type.enum';

export class ShipmentIntegration extends Model {
  @Expose() url: string;

  @Expose()
  @Type(() => ShipmentIntegrationAction)
  shipmentIntegrationLogs: ShipmentIntegrationAction[];

  @Expose()
  @Type(() => ShipmentIntegrationActionConfig)
  actionConfig: ShipmentIntegrationActionConfig;

  @Expose() integrationType:IntegrationType;

  // front end side only now
  @Expose() id: number;
  @Expose() get actions(): string[] {
    return Object.keys(this.actionConfig || {})?.filter((key) => this.actionConfig[key]);
  }

  @Expose() get actionsWithLogs(): { [key: string]: ShipmentIntegrationAction } {
    return (
      this.actions.reduce((acc, action) => {
        acc[action] = this.shipmentIntegrationLogs.find((log) => log.action === action);
        return acc;
      }, {}) || {}
    );
  }
}
